import Nav from "@/components/Nav";
import { Link } from "react-router-dom";
import { ScrollText } from "lucide-react";

const LEGAL_LINKS = [
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/refund", label: "Cancellation & Refund" },
  { to: "/shipping", label: "Shipping & Delivery" },
  { to: "/contact", label: "Contact Us" },
];

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Nav />
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
        {/* Sidebar */}
        <aside className="lg:col-span-3">
          <div className="sticky top-24 border border-stone-200 rounded-2xl bg-white p-5">
            <div className="flex items-center gap-2">
              <ScrollText size={16} className="text-amber-700" />
              <div className="overline">Legal · Compliance</div>
            </div>
            <nav className="mt-4 space-y-1">
              {LEGAL_LINKS.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`legal-nav-${l.to.replace("/", "")}`}
                  className={`block text-sm px-3 py-2 rounded-lg transition-colors ${
                    typeof window !== "undefined" && window.location.pathname === l.to
                      ? "bg-amber-50 text-[#1E1B4B] font-medium border border-amber-200"
                      : "text-stone-600 hover:bg-stone-50 hover:text-[#1E1B4B]"
                  }`}
                >
                  {l.label}
                </Link>
              ))}
            </nav>
            <p className="text-xs text-stone-400 mt-6 leading-relaxed">
              These policies apply to all Anubandh AI services accessed via anubandh.ai and any
              associated apps or channels.
            </p>
          </div>
        </aside>

        {/* Body */}
        <article className="lg:col-span-9 border border-stone-200 rounded-2xl bg-white p-8 lg:p-12">
          <div className="overline">Anubandh AI · Legal</div>
          <h1 className="font-serif-display text-4xl lg:text-5xl text-[#1E1B4B] mt-2">{title}</h1>
          {updated && (
            <div className="mt-3 text-xs text-stone-500">Last updated: {updated}</div>
          )}
          <div className="prose prose-stone mt-8 max-w-none text-stone-700 leading-relaxed text-[15px]">
            {children}
          </div>
        </article>
      </div>
    </div>
  );
}
